import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { TsButtonModule, TsPaginatorModule } from 'tsui';
import { importsRoutes } from './imports.routing';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ImportsSettingsComponent } from './imports.component';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { AlertBannerComponent } from 'app/shared/components/widgets/alert-banner/alert-banner.component';
import { ImportDialogComponent } from './components/import-dialog/import-dialog.component';
import { FieldsTemplateDialogComponent } from './components/fields-template-dialog/fields-template-dialog.component';

const materialImports = [
  MatIconModule,
  MatSortModule,
  MatMenuModule,
  MatChipsModule,
  MatInputModule,
  MatTableModule,
  MatButtonModule,
  MatDialogModule,
  MatSelectModule,
  MatStepperModule,
  MatTooltipModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatProgressBarModule,
  MatSlideToggleModule,
  MatProgressSpinnerModule,
];

@NgModule({
  declarations: [ImportsSettingsComponent, ImportDialogComponent, FieldsTemplateDialogComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(importsRoutes),
    CommonModule,
    PipesModule,
    ...materialImports,
    DirectivesModule,
    AlertBannerComponent,
    TsButtonModule,
    TsPaginatorModule,
  ],
})
export class ImportsModule {}
